import React from 'react';
import Dialog from '@components/2-molecules/Dialog';

interface ConfirmDialogProps {
  /** Whether the dialog is visible */
  show: boolean;
  /** Dialog title */
  title: string;
  /** Descriptive message or content */
  children: React.ReactNode;
  /** Label for the confirm button */
  confirmLabel?: string;
  /** Label for the cancel button */
  cancelLabel?: string;
  /** Whether the confirm action is in progress */
  loading?: boolean;
  /** Called when the user confirms */
  onConfirm: () => void;
  /** Called when the user cancels or closes the dialog */
  onCancel: () => void;
}

/**
 * Reusable confirmation dialog that wraps the core Dialog component.
 * Use this instead of `window.confirm()` for a consistent in-app experience.
 */
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  show,
  title,
  children,
  confirmLabel = 'OK',
  cancelLabel = 'Cancel',
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      show={show}
      headerTitle={title}
      onClose={onCancel}
      onCloseIconButtonClick={onCancel}
      onPrimaryButtonClick={onConfirm}
      primaryButtonLabel={confirmLabel}
      primaryButtonLoading={loading}
      onSecondaryButtonClick={onCancel}
      secondaryButtonLabel={cancelLabel}
      closeOnEscape
      closeOnClickOutside
    >
      {children}
    </Dialog>
  );
};

export default ConfirmDialog;
